import { styled } from 'styled-components';
import { blockStyle } from '../../../../../components/styles/Block';
import { tableGridColumns } from './styles';

export const HeaderBlock = styled.div`
  ${blockStyle}
  display: grid;
  grid-template-columns: ${tableGridColumns};
  gap: 16px;
`;

export const HeaderCell = styled.div`
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
`;
